import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    //this.router.navigate(['/optimizer']);
    //this.router.navigate(['/print']);
    /** Check if QueryString parameters are passed. If yes load the solution based on parameters provided.*/

    var params = this.getQueryParams();
    var investment = params["investment"];
    var ror = params["ror"];
    var sd = params["sd"];
    if (investment && investment.length > 0 && ror && ror.length > 0) {
      this.router.navigate(["./login"], { queryParams: params });
    } else {
      this.router.navigate(["./login"]);
    }
  }

  getQueryParams() {
    var url = window.location.href;
    var params = {};
    var parser = document.createElement("a");
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  }
}
